"use client";
import { useEffect, useState } from "react";
import type { FullStoryParameters } from ".";
import { FullStory } from ".";
import { FullStory as FullStoryLogger } from "@fullstory/browser";
import { usePathname } from "next/navigation";

const GDPR_COOKIE = "notice_gdpr_prefs";

const getCookie = async (
  cookie: string,
  setConsent: (updatedValue: boolean) => void,
) => {
  const cookieValue = await cookieStore.get(cookie);
  if (cookieValue?.value) {
    setConsent(cookieValue.value.includes("1"));
  } else {
    cookieStore.addEventListener("change", (event) => {
      for (const { name, value } of event.changed) {
        if (name === GDPR_COOKIE) {
          setConsent(value?.includes("1") ?? false);
        }
      }
    });
  }
};

export const FullStoryClient = (parameters: FullStoryParameters) => {
  const pathName = usePathname();
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    void getCookie(GDPR_COOKIE, setConsent);
  }, []);

  useEffect(() => {
    if (consent) {
      FullStory.initialize(parameters);
      FullStoryLogger("start");
    }
  }, [parameters, consent]);

  useEffect(() => {
    if (consent) {
      void FullStory.setProperties({
        properties: { variant: "DotNext" },
        type: "page",
      });
    }
  }, [consent, pathName]);

  return consent ? (
    <link href="https://edge.fullstory.com" rel="dns-prefetch" />
  ) : null;
};
